// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  Fragment,
  type Node,
} from 'react';

import {
  Colors,
  Heading,
  Img,
  Link,
  Margin,
  Text,
  Typography,
} from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import { type Size } from '@zapier/design-system-company';

/** @jsx isolateComponent */

type Props = {
  /** The links to display */
  children: Node,
  /** Size */
  size: Size,
};

const Styles = labelStyles(__filename, {
  buttonWrapper: {
    textAlign: 'center',
  },

  heading: {
    ...Typography.subtitle900,
    color: Colors.grey900,
    textAlign: 'center',
  },

  imageWrapper: {
    textAlign: 'center',
  },

  link: {
    textDecoration: 'underline',
  },

  topicLinksWrapper: {
    '& > *': {
      marginBottom: 10,
    },
  },
});

const TrialWelcomeModalIndexView = (props: Props) => (
  <Fragment>
    <div css={Styles.imageWrapper}>
      <Img
        alt="Zaplings greeting each other"
        src="https://cdn.zapier.com/storage/photos/b89f2ba87e86f44a08a726796a4106a4.png"
      />
    </div>

    <Heading css={Styles.heading}>
      Getting started with Zapier for Companies
    </Heading>

    <Margin margin={`20px ${props.size === 'small' ? '0' : '40px'}`}>
      <div css={Styles.topicLinksWrapper}>{props.children}</div>
    </Margin>

    <Text color="grey700" tag="p" textAlign="center" type="altText900">
      More questions?{' '}
      <Link
        color="grey700"
        css={Styles.link}
        href="/help/account/companies/get-started-with-zapier-for-companies"
      >
        View our documentation.
      </Link>
    </Text>

    <Text color="grey700" tag="p" textAlign="center" type="altText900">
      New to Zapier?{' '}
      <Link
        color="grey700"
        css={Styles.link}
        href="/learn/getting-started-guide"
      >
        Read our Getting Started guide.
      </Link>
    </Text>
  </Fragment>
);

export default TrialWelcomeModalIndexView;
